<template>
  <v-container class="pa-0 pb-r5" fluid>
    <v-row>
      <v-col class="pt-0">
        <h1 class="font-weight-light">Approve Venue</h1>
      </v-col>
    </v-row>

    <v-divider class="mb-8 mt-4"></v-divider>

    <v-row>
      <v-col>
        <v-card elevation="0" flat style="height: 100%">
          <v-card-title class="d-flex">
            <span class="flex-grow-1">Pending Venue</span>
          </v-card-title>
          <v-card-text class="d-flex flex-column pa-6 text-body-1">
            <v-row>
              <v-col cols="12" lg="6">
                <v-row>
                  <v-col>
                    <v-row class="pt-3" no-gutters>
                      <v-col class="flex-grow-1">
                        <v-text-field
                          v-model="venue.name"
                          class="rounded-r-0 border-right-0"
                          data-form-type="other"
                          dense
                          :error-messages="errors.name"
                          hide-details="auto"
                          label="Name"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col class="flex-grow-0 flex-shrink-1 text-right">
                        <v-btn
                          block
                          class="rounded-l-0 rounded-r"
                          color="secondary"
                          depressed
                          :href="`/admin/${venue.partner_id}/venue/${venue.id}`"
                          icon
                          outlined
                          target="_blank"
                        >
                          <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-select
                          v-model="selectedPassCategories"
                          dense
                          hide-details="auto"
                          item-text="name"
                          item-value="id"
                          :items="passCategories"
                          label="Categories"
                          :menu-props="{ maxHeight: '400' }"
                          multiple
                          outlined
                          placeholder="- Select Categories -"
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-row class="mt-3 pt-3" no-gutters>
                      <v-col class="flex-grow-1">
                        <v-text-field
                          v-model="venue.address"
                          :class="[
                            venue.address &&
                              (!venue.latitude || !venue.longitude) &&
                              'rounded-r-0 border-right-0'
                          ]"
                          data-form-type="other"
                          dense
                          :error-messages="errors.address"
                          hide-details="auto"
                          label="Address"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col
                        v-if="
                          venue.address && (!venue.latitude || !venue.longitude)
                        "
                        class="flex-grow-0 flex-shrink-1 text-right"
                      >
                        <v-btn
                          block
                          class="rounded-l-0"
                          color="secondary lighten-3"
                          depressed
                          @click="geoLocate"
                        >
                          <v-icon small>mdi-map-marker</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="venue.latitude"
                          data-form-type="other"
                          dense
                          :error-messages="errors.latitude"
                          hide-details="auto"
                          label="Latitude"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="venue.longitude"
                          data-form-type="other"
                          dense
                          :error-messages="errors.longitude"
                          hide-details="auto"
                          label="Longitude"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="venue.google_place_id"
                          data-form-type="other"
                          dense
                          :error-messages="errors.google_place_id"
                          hide-details="auto"
                          label="Google Place ID"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="venue.website"
                          data-form-type="other"
                          dense
                          :error-messages="errors.website"
                          hide-details="auto"
                          label="Website"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <bw-phone
                          v-model="venue.phone"
                          data-form-type="other"
                          dense
                          :error-messages="errors.phone"
                          hide-details="auto"
                          label="Phone"
                          outlined
                        ></bw-phone>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="venue.pin_number"
                          data-form-type="other"
                          dense
                          :error-messages="errors.pin_number"
                          hide-details="auto"
                          label="PIN Number"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-textarea
                          v-model="venue.description"
                          counter
                          data-form-type="other"
                          dense
                          :error-messages="errors.description"
                          label="Description"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="6">
                <v-row>
                  <v-col>
                    <div
                      id="map-canvas"
                      class="rounded"
                      style="width: 100%; max-width: 895px; height: 450px"
                      :style="
                        $vuetify.breakpoint.lgAndUp &&
                        'margin-top: 10px; height:334px;'
                      "
                    ></div>
                  </v-col>
                </v-row>

                <v-row v-if="closeVenues.length">
                  <v-col>
                    <label class="v-label v-label--active theme--light">
                      Close Venues
                    </label>
                    <v-data-table
                      :headers="closeVenueHeaders"
                      :items="closeVenues"
                      :items-per-page="20"
                    >
                      <template v-slot:item.name="{ item }">
                        <a
                          class="text-decoration-none"
                          :href="`/admin/${item.partner_id}/venue/${item.id}`"
                        >
                          {{ item.name }}
                        </a>
                      </template>
                      <template v-slot:item.miles="{ item }">
                        {{ item.miles }} miles
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>

                <v-row v-if="similarVenues.length">
                  <v-col>
                    <label class="v-label v-label--active theme--light">
                      Similar Venues
                    </label>
                    <v-data-table
                      :headers="similarVenueHeaders"
                      :items="similarVenues"
                      :items-per-page="20"
                    >
                      <template v-slot:item.name="{ item }">
                        <a
                          class="text-decoration-none"
                          :href="`/admin/${item.partner_id}/venue/${item.id}`"
                        >
                          {{ item.name }}
                        </a>
                      </template>
                      <template v-slot:item.similarity="{ item }">
                        {{ item.similarity.toFixed(2) }}
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn small @click="mergeVenueModal(item)">
                          Merge
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-card-subtitle class="d-flex">
              <span class="flex-grow-1">Venue Media</span>
            </v-card-subtitle>

            <v-row>
              <v-col>
                <div id="mediaDiv">
                  <bw-image-manager
                    v-for="(mediaData, idx) in venue.media"
                    :key="idx"
                    :description="mediaData.description"
                    :image-url="mediaData.url"
                    :name="mediaData.location"
                    :preview-size="[mediaData.div_width, mediaData.div_height]"
                    :size="[mediaData.width, mediaData.height]"
                    @crop="chooseImage(mediaData, 'edit')"
                    @remove="removeImage(mediaData)"
                    @select="chooseImage(mediaData)"
                  ></bw-image-manager>
                </div>
                <div v-if="errors.images" class="v-text-field__details">
                  <div class="v-messages theme--light error--text" role="alert">
                    <div class="v-messages__wrapper">
                      <div
                        class="v-messages__message message-transition-enter-to"
                      >
                        {{ errors.images }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-footer class="px-5 py-2 white" fixed>
      <v-col>
        <v-btn
          color="grey"
          :disabled="isUpdating"
          :href="allPendingVenuesLink"
          text
        >
          Cancel
        </v-btn>
      </v-col>
      <v-col class="align-center align-items-center text-right">
        <v-btn
          color="primary lighten-1"
          :disabled="isUpdating"
          :href="nextPendingLink"
          outlined
        >
          Skip
        </v-btn>
        <v-divider
          class="mx-2 vertical-align-middle"
          style="height: 38px"
          vertical
        ></v-divider>
        <v-btn
          color="primary"
          depressed
          :disabled="isUpdating"
          @click="saveVenue"
        >
          Save & Next
        </v-btn>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: 'ApproveVenue',
  props: {
    categories: {
      type: Array,
      default: () => {}
    },
    closeVenues: {
      type: Array,
      default: () => []
    },
    similarVenues: {
      type: Array,
      default: () => []
    },
    venue: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      addMarker: [],
      addresswindow: null,
      changeMedia: {},
      closeVenueHeaders: [
        {
          class: 'flex-grow-1',
          cellClass: 'flex-grow-1',
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Distance',
          value: 'miles'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      editMedia: {},
      errors: {},
      geocoder: null,
      isUpdating: false,
      map: null,
      marker: null,
      media: [
        {
          location: 'Header',
          description: '(2:1)',
          type: 'image',
          width: 400,
          height: 200,
          div_width: '325px',
          div_height: '160px',
          image: '',
          cropperSettings: {
            limitAR: '2:1',
            x: 0,
            y: 0
          }
        }
      ],
      mergeFields: {
        address: 0,
        website: 0,
        phone: 0,
        pin_number: 0,
        description: 0
      },
      mergeVenue: {},
      noGooglePlaceId: false,
      originalStatus: this.venue?.status,
      partnerId: this.venue?.partner_id,
      similarVenueHeaders: [
        {
          class: 'flex-grow-1',
          cellClass: 'flex-grow-1',
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Similarity',
          value: 'similarity'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      updatedVenue: {},
      venueApproved: 1,
      venueAutocomplete: null,
      venueStatusApproved: !!this.venue?.approved
    };
  },
  methods: {
    saveVenue() {
      if (this.validateForm()) {
        this.isUpdating = true;

        if (this.venueApproved) {
          this.venue.approved = 1;

          if (this.venueStatusApproved) this.venue.status = 4;
        } else this.venue.status = this.originalStatus;

        // fix the media structure to match the db tables
        if (this.venue.media && this.venue.media.length) {
          this.venue.media = this.venue.media.reduce((c, x) => {
            if (x.media_id) {
              // don't save defaults
              const nm = {
                id: x.id || 'null',
                media_id: x.media_id,
                x: x.x || 0,
                y: x.y || 0,
                width: x.width,
                height: x.height,
                rotation: x.rotation || 0,
                scale_x: x.scale_x || 1,
                scale_y: x.scale_y || 1,
                location: x.location,
                flag: x.flag
              };
              if (x.cropperSettings) {
                nm.x = x.cropperSettings.x || 0;
                nm.y = x.cropperSettings.y || 0;
                nm.width = x.cropperSettings.width;
                nm.height = x.cropperSettings.height;
                nm.rotation = x.cropperSettings.rotate || 0;
                nm.scale_x = x.cropperSettings.scaleX || 1;
                nm.scale_y = x.cropperSettings.scaleY || 1;
              }
              c.push(nm);
            }
            return c;
          }, []);
        }

        const url = `/venues/${this.venue.id}`;
        this.$axios
          .put(url, this.venue)
          .then(response => {
            const { data } = response;
            this.venue = data;
            this.prepareVenue();
            this.initialize();
            window.EventBus.$emit('system-messages', [{message: 'Venue updated successfully.', messageType: 'success'}]);
            this.isUpdating = false;

            window.location =
              '/admin-portal/<?= $venue->partner_id ?>/venues/approvals/next-pending-venue/<?= $venue->id ?>';
          })
          .catch(error => {
            window.EventBus.$emit('system-messages', [{message: error, messageType: 'error'}]);
            this.isUpdating = false;
          });
      } else this.isUpdating = false;
    },
    validateForm() {
      this.errors = {};

      if (!this.venue.name) this.errors.name = 'You must enter a name';

      if (!this.venue.address)
        this.errors.address = 'You must enter an address';

      if (!this.venue.latitude)
        this.errors.latitude = 'There must be a latitude';

      if (!this.venue.longitude)
        this.errors.longitude = 'There must be a longitude';

      if (!this.noGooglePlaceId && !this.venue.google_place_id)
        this.errors.google_place_id = 'There must be a Google Place Id';

      if (this.venue.google_place_id && this.closeVenues.length) {
        for (let i = 0; i < this.closeVenues.length; i += 1) {
          if (
            this.venue.google_place_id === this.closeVenues[i].google_place_id
          ) {
            window.EventBus.$emit('system-messages', [{message: `There is already a venue with this google place id. Merge this venue into the existing venue: ${this.closeVenues[i].name}`, messageType: 'error'}]);
            return false;
          }
        }
      }

      if (this.venueStatusApproved) {
        const regex = new RegExp('^https?://', 'i');
        if (this.venue.website && !regex.test(this.venue.website))
          this.errors.website = 'Website must start with http:// or https://';

        if (
          !this.venue.pin_number ||
          this.venue.pin_number.toString().length !== 4
        )
          this.errors.pin_number = 'You must enter a four digit pin number';

        if (!this.venue.description)
          this.errors.description = 'You must enter a description';

        for (let i = 0; i < this.venue.media.length; i += 1) {
          if (
            this.venue.media[i].location === 'Square' ||
            this.venue.media[i].location === 'Header'
          ) {
            if (
              !this.venue.media[i].originalURL ||
              this.venue.media[i].flag === 'delete'
            ) {
              this.errors.images = 'All images are required';
              break;
            }
          }
        }
      }

      if (Object.keys(this.errors).length === 0) return true;

      window.EventBus.$emit('system-messages', [{message: 'Please fix any errors before saving.', messageType: 'error'}]);
      return false;
    },
    mergeVenueModal(closeVenue) {
      this.mergeVenue = closeVenue;

      $('#merge-modal').modal('show');
    },
    mergeVenues() {
      if (this.validateMerge()) {
        this.isUpdating = true;

        if (this.mergeFields.address)
          this.mergeVenue.address = this.venue.address;

        if (this.mergeFields.website)
          this.mergeVenue.website = this.venue.website;

        if (this.mergeFields.phone) this.mergeVenue.phone = this.venue.phone;

        if (this.mergeFields.pin_number)
          this.mergeVenue.pin_number = this.venue.pin_number;

        if (this.mergeFields.description)
          this.mergeVenue.description = this.venue.description;

        const url = `/venues/${this.mergeVenue.id}`;
        this.$axios
          .put(url, this.mergeVenue)
          .then(response => {
            const { data } = response;
            this.mergeVenue = data;
            window.EventBus.$emit('system-messages', [{message: 'Existing venue updated successfully.', messageType: 'success'}]);
            this.isUpdating = false;

            window.location = `/admin-portal/${this.venue.partner_id}/venues/approvals/next-pending-venue/${this.venue.id}`;
          })
          .catch(error => {
            window.EventBus.$emit('system-messages', [{message: error, messageType: 'error'}]);
            this.isUpdating = false;
          });
      } else this.isUpdating = false;
    },
    validateMerge() {
      this.errors = {};

      if (this.mergeFields.address && !this.venue.address)
        this.errors.merge_address = 'You must enter an address';

      if (this.mergeFields.website && !this.venue.website)
        this.errors.merge_website = 'You must enter a website';

      if (this.mergeFields.phone && !this.venue.phone)
        this.errors.merge_phone = 'You must enter a phone number';

      if (
        this.mergeFields.pin_number &&
        (!this.venue.pin_number ||
          this.venue.pin_number.toString().length !== 4)
      )
        this.errors.merge_pin_number = 'You must enter a four digit pin number';

      if (this.mergeFields.description && !this.venue.description)
        this.errors.merge_description = 'You must enter a description';

      if (Object.keys(this.errors).length === 0) return true;

      window.EventBus.$emit('system-messages', [{message: 'Please fix any errors before saving.', messageType: 'error'}]);
      return false;
    },
    initialize() {
      const self = this;

      this.addresswindow = new google.maps.InfoWindow();

      const mapOptions = {
        center: new google.maps.LatLng(
          this.venue.latitude,
          this.venue.longitude
        ),
        zoom: 16,
        scrollwheel: false,
        mapTypeControl: true,
        streetViewControl: false,
        gestureHandling: 'greedy',
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          }
        ]
      };

      this.geocoder = new google.maps.Geocoder();
      this.map = new google.maps.Map(
        document.getElementById('map-canvas'),
        mapOptions
      );
      this.map.setTilt(0);

      this.marker = new google.maps.Marker({
        position: this.map.getCenter(),
        draggable: true,
        cursor: 'hand',
        map: this.map
      });

      google.maps.event.addListener(this.marker, 'dragend', event => {
        self.placeMarker(event.latLng);

        self.venue.latitude = self.map.center.lat();
        self.venue.longitude = self.map.center.lng();

        self.getCloseVenues();
      });

      google.maps.event.addListener(this.map, 'dragend', () => {
        self.placeMarker(self.map.getCenter());

        self.venue.latitude = self.map.center.lat();
        self.venue.longitude = self.map.center.lng();

        self.getCloseVenues();
      });
    },
    chooseImage(mediaData, type = 'new') {
      if (type === 'new') {
        this.changeMedia = mediaData;
        $('#media-manager').modal('show');
      } else if (type === 'edit') {
        this.editMedia = mediaData;
        $('#media-cropper').modal('show');
        // TODO: how to get the child component to call this every time the image changes?
        setTimeout(() => {
          this.$refs.cropper.setUpCropper(); // init the cropper tool, wait for modal to open
        }, 100);
      }
    },
    selectImage(e, mediaData) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], mediaData);
    },
    createImage(file, mediaData) {
      let index = this.venue.media.findIndex(
        name => name.location === mediaData.location
      );
      if (index === -1) index = this.venue.media.length;

      const reader = new FileReader();
      reader.onload = e => {
        if (typeof this.venue.media[index] === 'undefined') {
          this.venue.media[index] = {
            data: e.target.result,
            flag: 'new',
            location: mediaData.location,
            type: 'image'
          };
        } else {
          this.venue.media[index] = {
            data: e.target.result,
            flag: 'update',
            format: this.venue.media[index].format
              ? this.venue.media[index].format
              : '',
            location: this.venue.media[index].location,
            public_id: this.venue.media[index].public_id
              ? this.venue.media[index].public_id
              : '',
            type: 'image',
            url: this.venue.media[index].url ? this.venue.media[index].url : ''
          };
        }
        mediaData.url = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage(mediaData) {
      const media = this.venue.media.find(
        x => x.location === mediaData.location
      );
      if (media) {
        media.url = '';
        media.flag = 'delete';
      }
    },
    fileChosen(file) {
      this.changeMedia.url = file.url;
      this.changeMedia.originalURL = file.originalURL;
      this.changeMedia.media_id = file.id;

      // make sure the image is not flagged for removal
      delete this.changeMedia.flag;

      const i = this.venue.media.findIndex(
        name => name.location === this.changeMedia.location
      );
      if (i > -1)
        this.venue.media[i] = JSON.parse(JSON.stringify(this.changeMedia)); // break the reference pointer

      setTimeout(() => {
        this.changeMedia.cropperSettings.startFullCrop = true;
        this.chooseImage(this.changeMedia, 'edit');
      }, 250);
    },
    fileCropped(file) {
      this.editMedia = file;
      const i = this.venue.media.findIndex(
        x => x.location === this.editMedia.location
      );
      if (i > -1) {
        this.venue.media[i] = JSON.parse(JSON.stringify(this.editMedia)); // break the reference pointer
        this.media[i] = this.editMedia;
      }
      this.$forceUpdate();
    },
    getBoundsForAutocomplete() {
      if (this.venue.partnerAddress) {
        const g = new google.maps.Geocoder();
        g.geocode({ address: this.venue.partnerAddress }, (results, status) => {
          if (status === 'OK' && results.length) {
            let { bounds } = results[0].geometry;
            if (!bounds) {
              bounds = new google.maps.LatLngBounds(
                results[0].geometry.location
              );
            }

            this.venueInitAutocomplete(bounds);
          } else this.venueInitAutocomplete();
        });
      } else this.venueInitAutocomplete();
    },
    venueInitAutocomplete(bounds = false) {
      const mapOptions = {
        fields: [
          'name',
          'geometry.location',
          'place_id',
          'formatted_address',
          'formatted_phone_number',
          'website'
        ],
        types: [('address', 'establishment')]
      };

      if (bounds) {
        mapOptions.bounds = bounds;
        mapOptions.rankBy = google.maps.places.RankBy.DISTANCE;
      }

      this.venueAutocomplete = new google.maps.places.Autocomplete(
        document.getElementById('v-name'),
        mapOptions
      );

      this.venueAutocomplete.addListener(
        'place_changed',
        this.venueFillInAddress
      );
    },
    venueFillInAddress() {
      const place = this.venueAutocomplete.getPlace();

      if (place.geometry) {
        const { location } = place.geometry;
        const latitude = location.lat();
        const longitude = location.lng();
        const address = place.formatted_address;

        this.venue.name = place.name;
        this.venue.address = address;
        this.venue.latitude = latitude;
        this.venue.longitude = longitude;
        this.venue.phone = place.formatted_phone_number
          ? place.formatted_phone_number
          : '';
        this.venue.website = place.website ? place.website : '';
        this.venue.google_place_id = place.place_id ? place.place_id : '';

        this.map.setCenter({ lat: latitude, lng: longitude });
        this.map.setZoom(16);
        this.marker.setPosition({ lat: latitude, lng: longitude });

        this.getCloseVenues();
      }
    },
    geoLocate() {
      if (!this.venue.address) return;

      if (!this.venue.latitude || !this.venue.longitude) {
        const self = this;
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: this.venue.address }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            self.venue.latitude = results[0].geometry.location.lat();
            self.venue.longitude = results[0].geometry.location.lng();
          } else {
            alert(
              `Geocode was not successful for the following reason: ${status}`
            );
          }

          self.initialize();
        });
      }
    },
    getCloseVenues() {
      this.$axios
        .get(
          `/admin-portal/${this.partnerId}/venues/locations/get-close-venues/${this.venue.latitude}/${this.venue.longitude}?excludeVenueId=${this.venue.id}`
        )
        .then(response => {
          const { data } = response;

          this.closeVenues = data;

          this.populateCloseVenues();
        });
    },
    populateCloseVenues() {
      const self = this;

      this.closeVenues.forEach(closeVenue => {
        if (self.addMarker[`v-${closeVenue.id}`]) return;

        const infowindow = [];
        let venueInfo = '<p>';

        venueInfo += `<a href="/admin/${closeVenue.partner_id}/venue/${closeVenue.id}" target="_blank">${closeVenue.name}</a>`;
        if (closeVenue.website)
          venueInfo += ` - <a href="${closeVenue.website}">(website)</a>`;

        venueInfo += '</p>';

        self.addMarker[`v-${closeVenue.id}`] = new google.maps.Marker({
          position: new google.maps.LatLng(
            closeVenue.latitude,
            closeVenue.longitude
          ),
          map: self.map,
          title: closeVenue.name,
          icon: {
            url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
          }
        });

        infowindow[closeVenue.id] = new google.maps.InfoWindow({
          content: venueInfo
        });

        google.maps.event.addListener(
          self.addMarker[`v-${closeVenue.id}`],
          'click',
          () => {
            infowindow[closeVenue.id].open(
              self.map,
              self.addMarker[`v-${closeVenue.id}`]
            );
          }
        );
      });
    },
    placeMarker(location) {
      this.marker.setPosition(location);

      this.map.setCenter(location);
    },
    prepareVenue() {
      this.media = this.media.map(x => {
        let newX = x;
        const m = this.venue.media.find(y => x.location === y.location);
        if (m) {
          newX = {
            ...x,
            ...m,
            ...{
              scaleX: m.scale_x,
              scaleY: m.scale_y,
              cropperSettings: {
                limitAR: x.cropperSettings.limitAR,
                x: m.x,
                y: m.y,
                width: m.width,
                height: m.height
              }
            }
          };
        } // fix scale variables for cropper

        return newX;
      });
      this.venue.media = this.media;
    }
  },
  beforeMount() {
    this.prepareVenue();
  },
  mounted() {
    this.initialize();
    this.getBoundsForAutocomplete();
    this.populateCloseVenues();
  },
  computed: {
    allPendingVenuesLink() {
      if (!this.venue?.partner_id) return '';
      return `/admin-portal/${this.venue.partner_id}/venues/approvals/view-pending-venues`;
    },
    businessCategories: {
      get() {
        return this.categories.filter(
          x => !x.partner_id && this.venue.categories.includes(x.id)
        );
      }
    },
    nextPendingLink() {
      if (!this.venue?.partner_id) return '';
      return `/admin-portal/${this.venue.partner_id}/venues/approvals/next-pending-venue/${this.venue.id}`;
    },
    passCategories() {
      return this.categories.filter(x => x.partner_id);
    },
    selectedPassCategories: {
      get() {
        return this.categories.filter(
          x => x.partner_id && this.venue.categories.includes(x.id)
        );
      },
      set(val) {
        const ids = val.map(v => v.id);

        // dont clear out business categories
        // clear out old ones
        this.categories
          .filter(x => x.partner_id)
          .forEach(existing => {
            const i = this.venue.categories.indexOf(existing.id);
            if (i > -1) this.venue.categories.splice(i, 1);
          });

        // assign new ones
        ids.forEach(id => {
          if (!this.venue.categories.includes(id))
            this.venue.categories.push(id);
        });
      }
    }
  },
  watch: {
    isUpdating(value) {
      if (value) {
        // $().bwLoader(this.$el).start();
      } else {
        // $().bwLoader(this.$el).stop();
      }
    },
  }
};
</script>
